export default {
  logo: (state) => state.data.company.logo_url || "",
  jobTitle: (state) => state.data.vacancy.title,
  jobDescription: (state) => state.data.vacancy.description,
  workload: (state) => state.data.vacancy.workload,
  skills: (state) =>
    state.data.vacancy.skills ? state.data.vacancy.skills.split(",") : [],
  benefits: (state) =>
    state.data.vacancy.benefits ? state.data.vacancy.benefits.split(",") : [],
  salaryRange: (state) =>
    state.data.vacancy.remuneration_from && state.data.vacancy.remuneration_to
      ? `De R$: ${state.data.vacancy.remuneration_from.toFixed(
          2
        )} até R$: ${state.data.vacancy.remuneration_to.toFixed(2)}`
      : `R$: ${state.data.vacancy.remuneration.toFixed(2)}`,
  location: (state) => state.data.vacancy.location,
  isLoading: (state) => state.isFetchingVacancy,
  isLoadingInvite: (state) => state.isInviteRequest,
  talentId: (state) => state.data.talent_id,
  inviteStatus: (state) => state.data.status,
  showRegime: (state) => state.data.vacancy.show_regime,
  showLocation: (state) => state.data.vacancy.show_location,
  showRemuneration: (state) => state.data.vacancy.show_remuneration,
  regime: (state) => state.data.vacancy.regime.description,
  message: (state) => state.message,
};
